import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../react-app-env';

const _selectMenuInitQuery = (id: string) => ({
  locations: [
    {
      can_manage_menus: types.boolean,
    },
  ],
  menus_by_pk: params(
    { id: rawString(id) },
    {
      name: types.string,
    }
  ),
});

type X = Unpacked<typeof _selectMenuInitQuery>;
export type Location = X['locations'][0];
export type Menu = X['menus_by_pk'];

export const selectMenuInitQuery = (id: string) => gql`
  ${query(_selectMenuInitQuery(id))}
`;
